<template>
  <a-modal
    :visible="dialogVisible"
    :title="null"
    :width="600"
    :footer="null"
    :closable="false"
    destroyOnClose
    wrapClassName="search-modal-wrap"
    @cancel="onCancel"
  >
    <div class="search-modal">
      <a-input-search
        ref="searchInput"
        v-model="keyword"
        size="large"
        :placeholder="locale === 'zh' ? '搜索产品名称、规格...' : 'Search product name, specs...'"
        @search="onSearch"
        @pressEnter="onSearch"
      />
      <div class="search-results" v-if="results.length > 0">
        <div
          v-for="item in results"
          :key="item.id"
          class="search-item"
          @click="goProduct(item.id)"
        >
          <img :src="item.image" :alt="item.name" class="search-item-img" />
          <div class="search-item-info">
            <div class="search-item-name">{{ locale === 'zh' ? item.nameZh : item.name }}</div>
            <div class="search-item-spec">{{ locale === 'zh' ? item.specZh : item.spec }}</div>
          </div>
          <span class="search-item-cat">{{ locale === 'zh' ? item.categoryNameZh || item.categoryName : item.categoryName }}</span>
        </div>
      </div>
      <div v-else-if="keyword && searched" class="search-empty">
        {{ locale === 'zh' ? '未找到匹配产品' : 'No matching products found' }}
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'SearchModal',
  props: {
    visible: Boolean
  },
  data() {
    return {
      dialogVisible: false,
      keyword: '',
      results: [],
      searched: false
    }
  },
  computed: {
    locale() {
      return this.$store.locale
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.keyword = ''
        this.results = []
        this.searched = false
        this.$nextTick(() => {
          this.$refs.searchInput && this.$refs.searchInput.focus()
        })
      }
    }
  },
  methods: {
    onCancel() {
      this.dialogVisible = false
      this.$emit('close')
    },
    onSearch() {
      if (!this.keyword.trim()) return
      const kw = this.keyword.toLowerCase()
      const products = this.$store.products
      this.results = products.filter(p => {
        return p.name.toLowerCase().includes(kw) ||
               p.nameZh.includes(kw) ||
               p.spec.toLowerCase().includes(kw) ||
               p.specZh.includes(kw) ||
               p.categoryName.toLowerCase().includes(kw)
      })
      this.searched = true
    },
    goProduct(id) {
      this.onCancel()
      this.$router.push(`/products/${id}`)
    }
  }
}
</script>

<style lang="less">
@import '../../styles/variables.less';

.search-modal-wrap {
  .ant-modal-body {
    padding: 24px;
  }
}

.search-modal {
  .ant-input-search {
    .ant-input {
      border-radius: 6px;
      height: 48px;
      font-size: 16px;
    }
  }
}

.search-results {
  margin-top: 20px;
  max-height: 360px;
  overflow-y: auto;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background @duration-fast;

  &:hover {
    background: @bg-light;
  }

  &-img {
    width: 48px;
    height: 48px;
    object-fit: cover;
    border-radius: 4px;
    background: @bg-light;
  }

  &-info {
    flex: 1;
    min-width: 0;
  }

  &-name {
    font-size: 14px;
    font-weight: 500;
    color: @text-primary;
  }

  &-spec {
    font-size: 12px;
    color: @text-secondary;
    margin-top: 2px;
  }

  &-cat {
    font-size: 12px;
    color: @accent-teal;
    background: fade(@accent-teal, 10%);
    padding: 2px 8px;
    border-radius: 10px;
    flex-shrink: 0;
  }
}

.search-empty {
  text-align: center;
  padding: 32px 0;
  color: @text-secondary;
  font-size: 14px;
}
</style>
